import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { WizardStepItem } from 'app/components/feat-edit/edit-wizard/wizard-step-title/wizard-step-title.component';
import { A3iService } from 'app/services/a3i.service';
import { ActivityService } from 'app/services/activity.service';
import { AppinfoService } from 'app/services/appinfo.service';
import { AttrIndexService } from 'app/services/attr-index.service';
import { CommonFunctionService } from 'app/services/common-function.service';
import { EditService } from 'app/services/edit.service';
import { FieldMappingService, LayerCategory, LayerCategoryStandardSchema } from 'app/services/field-mapping.service';
import { FloatPopupService } from 'app/services/float-popup.service';
import { GfoService } from 'app/services/gfo.service';
import { LayerQcService } from 'app/services/layer-qc.service';
import { LayerService } from 'app/services/layer.service';
import { MainDataMapLayersService } from 'app/services/main-data-map-layers.service';
import { MainDataMapService } from 'app/services/main-data-map.service';
import { MainDataService } from 'app/services/main-data.service';
import { UserService } from 'app/services/user.service';
import { LRSMap } from 'assets/TS/LRSMap_New';
import { fadeInOut } from 'assets/TS/SharedAnimations';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

type StepProp = 'setParsing' | 'setEntireStreet' | 'selectRCLs';
interface A3iWizardStepItem extends WizardStepItem {
	prop: StepProp;
}

@Component({
  selector: 'app-a3i-wizard',
  templateUrl: './a3i-wizard.component.html',
  styleUrls: ['./a3i-wizard.component.css'],
  animations: [fadeInOut]
})
export class A3iWizardComponent implements OnInit, AfterViewInit, OnDestroy {

	currentStep: A3iWizardStepItem;
	steps: A3iWizardStepItem[] = [
		{
			num: 1,
			label: 'Set parsing direction',
			prop: 'setParsing',
			isFirst: true
		}, {
			num: 2,
			label: 'Extend RCL selection to entire street',
			prop: 'setEntireStreet',
		}, {
			num: 3,
			label: 'Select RCL(s)',
			prop: 'selectRCLs',
			isLast: true
		}
	];

	parsingDirection: 'legacyToNena' | 'nenaToLegacy' = 'legacyToNena';
	isExtendEntireStreet: boolean = true;

	// selectedRoads: any[] = [];
	private selectedRoadsById: {
		[id: string]: {
			feat?;
			attrs?;
			extendMark?;
			parseAddress?: string;
			parseResult?;
		}
	} = {};
	private centerlineLayerId;
	private centerlineCate: LayerCategory;
	private lstStandardCols: LayerCategoryStandardSchema[];
	private stStandardCols: LayerCategoryStandardSchema[];

	private map: LRSMap.Map;

	private mapSub: Subscription;
	private mapMoveendSub: Subscription;

	constructor(
		private toastr: ToastrService,
		private a3iService: A3iService,
		private activityService: ActivityService,
		private appinfoService: AppinfoService,
		private attrIndexService: AttrIndexService,
		private commonService: CommonFunctionService,
		private editService: EditService,
		private fieldMappingService: FieldMappingService,
		private floatPopupService: FloatPopupService,
		private gfoService: GfoService,
		private layerService: LayerService,
		private mainDataService: MainDataService,
		private mapService: MainDataMapService,
		private mapLayerService: MainDataMapLayersService,
		private qcService: LayerQcService,
		private userService: UserService
	) { }

	close() {
		this.removeAll()
		this.floatPopupService.closePopup(A3iWizardComponent);
	}
	cancel() {
		this.close();
	}
	private async apply() {
		const prefix = this.centerlineCate.colPrefix;
		const addresses: string[] = [];
		const cols = this.parsingDirection === 'legacyToNena' ? this.lstStandardCols : this.stStandardCols;
		Object.keys(this.selectedRoadsById).forEach(featId => {
			if (!this.selectedRoadsById[featId] || !this.selectedRoadsById[featId].attrs) {
				this.toastr.warning('Cannot find attribute for line ' + featId);
				return;
			}
			const attrs = this.selectedRoadsById[featId].attrs;

			const inputAddr = this.a3iService.combinePartsToAddress(cols, prefix, attrs);
			this.selectedRoadsById[featId].parseAddress = inputAddr;
			if (addresses.indexOf(inputAddr) === -1) {
				addresses.push(inputAddr);
			}
		})
		const spinnerId = this.commonService.getRandomId();
		this.commonService.setLoadingSpinner(true, spinnerId);
		try {
			const rsp = await this.a3iService.parseAddress(addresses, this.userService.customerInfo.givState);
			this.handleParseResult(rsp.data);
			this.selectedRoadsById = {};
			this.close();
		} catch (err) {
			console.log(err);
			this.toastr.error('Failed.');
		}
		this.commonService.setLoadingSpinner(false, spinnerId);
	}

	checkGoNextDisabled(stepProp: StepProp) {
		switch (stepProp) {
			case 'selectRCLs':
				return !Object.keys(this.selectedRoadsById).length;
		}
	}
	goPrev() {
		if (this.currentStep.isFirst) {
			return;
		}
		const stepNum = this.currentStep.num - 1;
		const step = this.steps.find(i => i.num === stepNum);
		this.changeCurrentStep(step);
	}
	goNext() {
		// Last step: add cards
		if (this.currentStep.isLast) {
			this.apply();
			return;
		}

		const stepNum = this.currentStep.num + 1;
		const step = this.steps.find(i => i.num === stepNum);
		// if (this.checkGoNextDisabled(step.prop)) {
		// 	return;
		// }
		this.changeCurrentStep(step);
	}

	private removeAll() {
		this.mapService.endPickOnMap(this.map);
		if (this.map.addedLayers[this.mapLayerService.addressLineLayerName]) {
			this.map.removeLayer(this.mapLayerService.addressLineLayerName);
		}
	}
	private changeCurrentStep(step: A3iWizardStepItem) {
		if (this.currentStep && this.currentStep.prop === 'selectRCLs') {
			this.mapService.endPickOnMap(this.map);
		}
		switch (step.prop) {
			case 'setParsing':
				break;
			case 'selectRCLs':
				this.startPickLine();
				break;
		}
		this.currentStep = step;
	}
	private startPickLine() {
		const layers = [this.mapLayerService.dataLayerName, this.mapLayerService.bgSurroundingsLayerName];
		this.mapService.startPickOnMap(this.map, layers, async (result) => {
			const line = result.feat;
			if (line) {
				const lineLayer = this.map.addedLayers[this.mapLayerService.addressLineLayerName];
				const featId = line.getId();
				let info = this.selectedRoadsById[featId];
				if (info) {
					const extendMark = info.extendMark;
					delete this.selectedRoadsById[featId];
					lineLayer.getSource().removeFeature(line);
					// Remove extended lines
					if (this.isExtendEntireStreet && extendMark) {
						Object.keys(this.selectedRoadsById).forEach(id => {
							const otherLine = this.selectedRoadsById[id];
							if (otherLine.extendMark === extendMark) {
								if (otherLine.feat) {
									lineLayer.getSource().removeFeature(otherLine.feat);
								}
								delete this.selectedRoadsById[id];
							}
						})
					}
				} else {
					await this.updateRoadsInfo([featId]);
					info = this.selectedRoadsById[featId]
					info.feat = line;
					lineLayer.getSource().addFeature(line);

					// Extended lines
					if (this.isExtendEntireStreet) {
						const extendMark = this.commonService.getRandomId();
						info.extendMark = extendMark;
						//
						const grdId = info.attrs[this.attrIndexService.rcIdCol];
						const extendedIds = await this.a3iService.getRclByRcl(this.centerlineLayerId, grdId);
						await this.updateRoadsInfo(extendedIds);
						extendedIds.forEach(id => {
							this.updateStoredFeat(id);
							this.selectedRoadsById[id].extendMark = extendMark;
						})
					}
				}
			} else {
				this.toastr.info('Centerline not found.')
			}
		});
		this.mapService.addMapDblclickStop(this.map, () => {
			this.mapService.endPickOnMap(this.map);
		});
	}
	private async updateRoadsInfo(featIds: string[]) {
		const spinnerId = this.commonService.getRandomId();
		this.commonService.setLoadingSpinner(true, spinnerId);
		try {
			const idsWithoutAttr = featIds.filter(id => {
				if (!this.selectedRoadsById[id] || !this.selectedRoadsById[id].attrs) {
					const attrs = this.mainDataService.getDataAttrs(id);
					if (attrs) {
						if (!this.selectedRoadsById[id]) {
							this.selectedRoadsById[id] = {}
						}
						this.selectedRoadsById[id].attrs = attrs;
						return false;
					}
					return true;
				}
			});
			if (idsWithoutAttr.length) {
				const filter = this.gfoService.getFilter(this.attrIndexService.rcUuidCol, this.appinfoService.filterOperators.in.name, idsWithoutAttr);
				const gfo = this.gfoService.getGfo(this.gfoService.filterLogics.and, [filter]);
				const rsp = await this.qcService.getQcFeatureReport(this.centerlineLayerId, null, gfo, {
					pageNumber: 0
				});
				if (rsp.data) {
					rsp.data.forEach(data => {
						const featId = data[this.attrIndexService.rcUuidCol];
	
						this.mainDataService.addDataToStoredRecords([data], this.attrIndexService.rcUuidCol, 'replace');
						
						if (!this.selectedRoadsById[featId]) {
							this.selectedRoadsById[featId] = {}
						}
						this.selectedRoadsById[featId].attrs = data;
					});
				} else {
					this.toastr.warning('Can not find centerline attributes.');
				}
			}
		} catch (err) {
			console.log(err)
		}
		this.commonService.setLoadingSpinner(false, spinnerId);
	}
	private updateStoredFeat(id) {
		const layers = [this.mapLayerService.dataLayerName, this.mapLayerService.bgSurroundingsLayerName];
		const lineLayer = this.map.addedLayers[this.mapLayerService.addressLineLayerName];
		if (!lineLayer.getSource().getFeatureById(id)) {
			layers.find(name => {
				const layer = this.map.addedLayers[name];
				const feat = layer.getSource().getFeatureById(id);
				if (feat) {
					this.selectedRoadsById[id].feat = feat;
					lineLayer.getSource().addFeature(feat);
					return true;
				}
			})
		}
	}
	private handleParseResult(data) {
		let numOfChangedCards = 0;
		if (data) {
			data.forEach(result => {
				const inputAddr = result[this.attrIndexService.parseInputAddrCol];
				const roadIds = Object.keys(this.selectedRoadsById).filter(id => this.selectedRoadsById[id].parseAddress === inputAddr);

				roadIds.forEach(id => {
					const changedAttrs = [];
					let attrs = this.selectedRoadsById[id].attrs;
					this.stStandardCols.forEach(col => {
						const colProp = this.centerlineCate.colPrefix + '_' + col.colName.toLowerCase();
						const resultProp = col.colName.toLowerCase();
						if (this.editService.hasValueChanged(attrs[colProp], result[resultProp])) {
							changedAttrs.push(colProp);
							attrs[colProp] = result[resultProp];
						}
					});
					this.lstStandardCols.forEach(col => {
						const colProp = this.centerlineCate.colPrefix + '_' + col.colName.toLowerCase();
						const resultProp = col.colName.toLowerCase();
						if (this.editService.hasValueChanged(attrs[colProp], result[resultProp])) {
							changedAttrs.push(colProp);
							attrs[colProp] = result[resultProp];
						}
						// attrs[colProp] = result[resultProp];
					})
					if (!this.mainDataService.getDataAttrs(id)) {



					} else if (changedAttrs.length) {
						changedAttrs.forEach(key => this.mainDataService.setDataAttrs(id, key, attrs[key]));
						this.mainDataService.addRecToCard(id);
						numOfChangedCards++;
					}
				})
			});
			if (numOfChangedCards === 0) {
				this.toastr.info('No change is needed');
			} else {
				this.activityService.changeTabSubject.next({
					tabKey: 'data'
				});
				this.toastr.info('Added to cards');
			}
		}
	}
	async ngOnInit() {
		this.centerlineLayerId = this.layerService.layerListBS.getValue().layers.find(l => l.category.code === this.attrIndexService.cateCodeCenterline).id;

		const centerlineLayerCate = this.appinfoService.layerTypeList.find(i => i.code === this.attrIndexService.cateCodeCenterline);
		if (!centerlineLayerCate.standardCols) {
			try {
				const stdSchema = await this.fieldMappingService.getStandardSchema(centerlineLayerCate.id);
				centerlineLayerCate.standardCols = stdSchema;
			} catch (err) {
				this.toastr.info('Centerline layer schema not found.');
				console.log(err);
			}
		}
		this.centerlineCate = centerlineLayerCate;

		this.lstStandardCols = this.a3iService.getLstStandardCols(centerlineLayerCate.standardCols);
		this.stStandardCols = this.a3iService.getStStandardCols(centerlineLayerCate.standardCols);

		this.changeCurrentStep(this.steps[0]);
	}
	ngAfterViewInit(): void {
		this.mapSub = this.mapService.mapBS.subscribe(data => {
			this.map = data;
			if (!this.map.addedLayers[this.mapLayerService.addressLineLayerName]) {
				this.mapLayerService.addAddressLineLayer(this.map);
			}
		});
		this.mapMoveendSub = this.mapService.mapMoveendSubject.subscribe(data => {
			if (this.currentStep && this.currentStep.prop === 'selectRCLs') {
				Object.keys(this.selectedRoadsById).forEach(id => {
					if (!this.selectedRoadsById[id].feat) {
						this.updateStoredFeat(id);
					}
				})
			}
		})
	}
	ngOnDestroy(): void {
		this.mapSub.unsubscribe();
		this.mapMoveendSub.unsubscribe();
	}
}
